import React, { Component } from 'react';

import api from 'core/utils/api';
import Spin from 'components/ui/Spin';
import NotificationsList from './NotificationsList';

class NotificationsContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
    };
  };

  componentDidMount() {
    api.get('/notifications')
      .then((res) => {
        const { notifications } = res.data;
        this.setState({
          notifications,
          loading: false,
        });
      });
  }

  handleReadAt = (id, updateState = true) => {
    api.put(`/notifications/${id}`)
      .then((res) => {
        const { notification } = res.data;
        const { notifications } = this.state;

        // hack to ignore error :|
        if (!updateState) { return; }

        this.setState({
          notifications: notifications.map((n) => {
            if (n.id === notification.id) {
              n.read_at = notification.read_at;
            }
            return n;
          }),
        });
      });
  };

  render() {
    const { loading, notifications } = this.state;

    if (loading) {
      return <Spin />;
    }

    return (
      <NotificationsList
        notifications={notifications}
        onReadAt={this.handleReadAt}
      />
    );
  }
}

export default NotificationsContainer;



// WEBPACK FOOTER //
// ./src/features/dashboard/NotificationsContainer.js